import React, { useState } from "react";
import { getInitialDate } from "../../../helper/formatDate";

import "./profitHeaderReport.css";

const ProfitHeaderReport = ({ onSearchButtonCliked }) => {
  const [startDate, setStartDate] = useState(getInitialDate("daily"));
  const [endDate, setEndDate] = useState(getInitialDate("daily"));
  return (
    <div className="profit-container">
      <input
        className="profit-input-date"
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
      />
      <input
        className="profit-input-date"
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
      />
      <button
        className="profit-search-button"
        onClick={() => {
          onSearchButtonCliked(startDate, endDate);
        }}
      >
        Cari Laporan Profit
      </button>
    </div>
  );
};

export default ProfitHeaderReport;
